import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

// ADD THESE IMPORTS (RxJS v5 style)
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/observable/interval';
import 'rxjs/add/observable/merge';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/shareReplay';
import { Observable } from 'rxjs/Observable'; // alias to use RxObservable.of / merge
import { interval } from 'rxjs/observable/interval';
import { merge } from 'rxjs/observable/merge';
import { of } from 'rxjs/observable/of';



@Injectable()
export class PushNotificationService {

  constructor(
    private http:HttpClient) { }

      private refresh$ = new BehaviorSubject<void>(undefined);

    public enviarPushOperador(token)
    {
        let body = 'token=' + token;
        const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});
        return this.http.post('https://operacion.trosten.com/push-service/notificarOperador.php?token='+token,body,{headers});
    }

    public enviarPushCambioTuristico(push,token)
    {
        let tokens = [];
        tokens.push(token);
        var body = JSON.stringify({
            "app_id": "a6d7cc04-6d57-4ff2-9bff-9395a8ae827b",
            "include_player_ids": tokens,
            "contents": {
                "es": push.mensaje,
                "en":push.mensaje
            },
            "headings":{
                "en": push.titulo,
                "es": push.titulo
            },
        })

        const headers = new HttpHeaders({
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'Authorization': 'Basic NjU5YjNmZWItYjkxMC00NGI3LTlmNTEtNDI5NjMxMTU4ZTA3'
        });
        return this.http.post("https://onesignal.com/api/v1/notifications",
            body, {headers})
    }
    public enviarPush(push,token)
    {
        console.log("enviarPush",push,token)
        let tokens = [];
        tokens.push(token);
        var body = JSON.stringify({
            "app_id": "5136d718-23bb-42d7-ada0-15dc1e2155f7",
            "include_player_ids": tokens,
            "contents": {
                "es": push.mensaje,
                "en":push.mensaje
            },
            "headings":{
                "en": push.titulo,
                "es": push.titulo
            },
        })

        const headers = new HttpHeaders({
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'Authorization': 'Basic YmE5NmRmNTktZjE1NS00MTkyLWFiNWYtZWVlODYyYmFmNDc4'
        });
        return this.http.post("https://onesignal.com/api/v1/notifications",
            body, {headers})
    }

    public enviarPushUsuario(push,token,usuario_envio,idTrosten,confirmacion,razon = "")
    {
        let body = 'token=' + token+
            '&mensaje=' + push.mensaje +
            '&titulo=' + push.titulo+
            '&type=' + push.type+
            '&idTrosten=' + idTrosten +
            '&confirmacion=' + confirmacion +
            '&razon=' + razon +
            '&usuario_envio=' + usuario_envio;
        const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});
        return this.http.post('https://operacion.trosten.com/corp-school/php/admin/WebPush/notificarUsuario.php',body,{headers});

        /*
          const headersC = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});

          const body = 'token=' + token;
          return this.httpC.post('https://trosten.azurewebsites.net/push-service/notificarOperador.php', body,{headersC});
          */
    }
    public obtenerNotificacionesPorAgente(idUsuario)
    {
        let body = 'idUsuario=' + idUsuario;
        const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});
        return this.http.post('https://operacion.trosten.com/corp-school/php/admin/WebPush/obtenerNotificacionesPorAgente.php',body,{headers});
    }

    public obtenerNotificacionesStream(idUsuario: string, pollMs: number = 15000): Observable<any[]> {
    // tick$ + refresh$ merged, and start immediately
    const trigger$ = merge(interval(pollMs), this.refresh$).startWith(0);

    return trigger$
      .switchMap(() =>
        this.obtenerNotificacionesPorAgente(idUsuario) // your existing HTTP POST
          .map((list: any) => Array.isArray(list) ? list : []) // backend should return an array
          .map(arr =>
            arr.map(n => ({
              ...n,
              // normalize vista to number (handles "0"/"1" strings)
              vista: typeof n.vista === 'string' ? Number(n.vista) : n.vista
            }))
          )
          .catch(_ => of([])) // keep stream alive on errors
      )
      .shareReplay(1);
  }

  /**
   * Live count of "nuevas" (vista === 0)
   */
  public obtenerNuevasCount$(idUsuario: string, pollMs: number = 15000): Observable<number> {
    return this.obtenerNotificacionesStream(idUsuario, pollMs)
      .map(list => list.filter(n => Number(n.vista) === 0).length)
      .shareReplay(1);
  }

  public forceRefresh() {
    this.refresh$.next(undefined);
  }

  public marcarComoVista(idNotificacion: string): Observable<any> {
    const body = 'idNotificacion=' + idNotificacion;
    const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});
    return this.http
      .post('https://operacion.trosten.com/corp-school/php/admin/WebPush/marcarComoVista.php', body, { headers })
      .map(res => {
        this.refresh$.next(undefined); // 🔔 update badge immediately
        return res;
      });
  }
}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/services/pushNotification.service.ts